import React from "react";
import styled, { keyframes } from "styled-components";
import SVG from "react-inlinesvg";

const DesktopOnboardingTooltip = () => {
  return (
    <TooltipContainer>
      <HandPointer src="/assets/pointer-hand.svg" />
      <Tooltip>To leave a comment, highlight some text.</Tooltip>
    </TooltipContainer>
  );
};

const bounce = keyframes`
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-10px);
  }
`;

const TooltipContainer = styled.div`
  position: absolute;
  right: -210px;
  top: 60px;
  display: flex;
  align-items: center;
  animation: ${bounce} 2s infinite;
  z-index: 100;
  line-height: 1.3;
`;

const HandPointer = styled(SVG)`
  width: 100px;
  height: auto;
  margin-top: -10px;
  margin-right: -40px;
`;

const Tooltip = styled.div`
  font-weight: 500;
  background-color: #333;
  color: white;
  padding: 12px 16px;
  border-radius: 15px;
  font-size: 16px;
  max-width: 160px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
`;

export default DesktopOnboardingTooltip;
